var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('DropdownSelect',_vm._b({on:{"toggle":_vm.toggle}},'DropdownSelect',{ options: _vm.options, pageSize: _vm.pageSize, selected: _vm.pageSize },false))],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field"},[_c('label',[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fal fa-bars"})]),_c('span',[_vm._v("Items per page")])])])
}]

export { render, staticRenderFns }